import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, applyQueryString, notify } from 'services';
import {
  ListAreasActions as Actions,
  ListAreasRequestAction as RequestAction,
} from 'store/ducks/areas';

export function* listAreasRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('areas', {
      ...query,
      asList: 1,
      orderBy: 'name',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
